<template>
  <div class="category-pie" ref="chartContainer"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { TooltipComponent, LegendComponent, TitleComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { categoryData } from '../mock/data'

echarts.use([PieChart, TooltipComponent, LegendComponent, TitleComponent, CanvasRenderer])

export default {
  name: 'CategoryPie',
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      var colors = ['#00D4FF', '#00FF88', '#FF6B35', '#A855F7', '#F59E0B', '#EC4899', '#06B6D4']
      var option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 },
          formatter: function(p) {
            return p.name + '<br/>销售额: ' + (p.value / 10000).toFixed(1) + '万元<br/>占比: ' + p.percent + '%'
          }
        },
        legend: {
          orient: 'vertical',
          right: 5,
          top: 'center',
          textStyle: { color: '#B0D4F1', fontSize: 11 },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 6
        },
        series: [{
          type: 'pie',
          roseType: 'area',
          radius: ['20%', '65%'],
          center: ['40%', '50%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: '{b}\n{d}%',
            fontSize: 10,
            color: '#B0D4F1',
            lineHeight: 14
          },
          labelLine: {
            show: true,
            length: 10,
            length2: 10,
            lineStyle: { color: 'rgba(0,212,255,0.3)' }
          },
          emphasis: {
            label: { show: true, fontSize: 14, fontWeight: 'bold', color: '#FFFFFF' },
            itemStyle: {
              shadowBlur: 20,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0,0,0,0.6)'
            }
          },
          data: categoryData.map(function(d) {
            return {
              name: d.name,
              value: d.value
            }
          }),
          itemStyle: {
            color: function(params) {
              return colors[params.dataIndex % colors.length]
            },
            borderColor: 'rgba(6,30,60,0.85)',
            borderWidth: 2
          }
        }]
      }
      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.category-pie {
  width: 100%;
  min-height: 200px;
}
</style>
